




















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Modal from '@/app/ui/components/Modal/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import { IOptions } from '@/data/infrastructures/misc/interfaces/pickupCRROTW'
import { Utils } from '@/app/infrastructures/misc'
import PickupController from '@/app/ui/controllers/PickupController'
import { ManageCourier, ManageCourierAdjustSaldo, ManageCouriers } from '@/domain/entities/ManageCourier'
import TextInput from '@/app/ui/components/TextInput/index.vue'

@Component({
  components: {
    Modal,
    Button,
    DropdownSelect,
    TextInput
  },
})
class TransferPickupModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly visible!: boolean
  @Prop({ type: String, default: 'transfer' }) readonly flow!:
    | 'transfer'
    | 'markDone'
  @Prop({ type: Number, default: 0 }) readonly senderCount!: number
  @Prop({ type: Number, default: 0 }) readonly totalShipments!: number
  @Prop({ type: Number, default: 0 }) readonly totalKoli!: number
  @Prop({ type: Boolean, default: false }) readonly submitting!: boolean
  @Prop({ type: Array, default: () => [] }) readonly excludeCourierId!: number[]

  selectedCourier: IOptions | null = null
  isLoadingCouriers = false
  courierOptions: IOptions[] = []
  pickupController = PickupController
  hubPersonName = ""
  personName = ""

  get modalTitle(): string {
    return this.flow === 'markDone'
      ? `Tandai selesai untuk ${this.senderCount} pengirim?`
      : `Transfer pick up dari ${this.senderCount} pengirim?`
  }

  get modalSubtitle(): string {
    return this.flow === 'markDone'
      ? 'Anda akan menandai pickup selesai untuk grup terpilih.'
      : 'Anda akan melakukan transfer pick up.'
  }

  get primaryButtonLabel(): string {
    return this.flow === 'markDone' ? 'Tandai Selesai' : 'Transfer'
  }

  get canSubmit(): boolean {
    if (this.submitting) return false
    if (this.flow === 'markDone') {
      return !!this.hubPersonName && !!this.personName
    }
    return (
      this.selectedCourier != null &&
      this.selectedCourier.value !== '' &&
      this.selectedCourier.value !== undefined
    )
  }

  @Watch('visible')
  onVisibleChange(v: boolean): void {
    if (!v) {
      this.selectedCourier = null
    }
  }

  getCouriers(q = "", driverType = 'POS'): Promise<ManageCouriers> {
    const filtered = [...new Set(this.excludeCourierId.filter(id => id > 0))]
    return this.pickupController.getCouriers({
      courierStatus: 'ACTIVE',
      driverType,
      perPage: 10,
      notIn: filtered.length ? filtered.join(",") : "",
      q,
    })
  }

  async onCourierSearch(search: string): Promise<void> {
    try {
      this.isLoadingCouriers = true
      const [POS, KVP] = await Promise.allSettled([
        this.getCouriers(search, 'POS'),
        this.getCouriers(search, 'KVP'),
      ])
      this.isLoadingCouriers = false
      const POSData = POS.status === 'fulfilled' ? POS.value.data as ManageCourier[] : []
      const KVPData = KVP.status === 'fulfilled' ? KVP.value.data as ManageCourier[] : []

      const couriers = POSData.concat(KVPData);

      this.courierOptions = couriers.map((courier: ManageCourierAdjustSaldo) => {
        const label = `[${courier.courierId}] ${courier.fullName} (${courier.announcementCourierType}) ${courier.phoneNumber} • ${courier.partnerName}`
        const value = courier.courierId

        return {
          label: label,
          value: value,
        } as IOptions
      })
    } catch (error: any) {
      console.log(error);
      Vue.notify({
        title: 'Fetch Manage Courier Failed',
        text: [400, 422].includes(error.status)
          ? error.error.message.en
          : 'Something wrong',
        type: 'error',
        duration: 5000,
      })
    } finally {
      this.isLoadingCouriers = false
    }
  }

  onCourierSearchDebounce = Utils.debounce((search: string) => {
    this.onCourierSearch(search)
  }, 300)

  onCourierInput(opt: IOptions | null): void {
    this.selectedCourier = opt
  }

  onClose(): void {
    if (this.submitting) return
    this.$emit('close')
  }

  onConfirm(): void {
    if (this.submitting) return
    if (!this.canSubmit) return
    if (this.flow === 'markDone') {
      this.$emit('confirm-mark-done', {
        hubPersonName: this.hubPersonName,
        personName: this.personName
      })
      this.hubPersonName = "";
      this.personName = "";

      return
    }
    if (this.selectedCourier == null) return
    const id = Number(this.selectedCourier.value)
    if (!Number.isFinite(id)) return
    this.$emit('confirm', id)
  }
}
export default TransferPickupModal;
